// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import { GetMaterialsInput, PaginationInput } from '../../../gql/graphql';

const materialKeys = {
  all: ['material'] as const,
  categories: ['material', 'categories'] as const,
  material: (id: string) => [...materialKeys.all, id] as const,
  materials: (pagination?: PaginationInput, input?: GetMaterialsInput) => {
    if (!pagination) {
      return [...materialKeys.all, 'materials'] as const;
    }

    if (!input) {
      return [...materialKeys.all, 'materials', pagination] as const;
    }

    return [...materialKeys.all, 'materials', pagination, input] as const;
  },
  accountPreferredProducts: () =>
    [...materialKeys.all, 'accountPreferredProducts'] as const,
  productSpecs: (category: string, searchTerm?: string) =>
    [...materialKeys.all, 'productSpecs', category, searchTerm] as const,
  infiniteMaterials: (input?: GetMaterialsInput) => {
    if (!input) {
      return ['material', 'infiniteMaterials'] as const;
    }

    return ['material', 'infiniteMaterials', input] as const;
  },
};

export default materialKeys;
